import {useEffect, useState} from 'react'
import {useLazyQuery} from '@apollo/client'
import {Button, Card, Placeholder} from 'react-bootstrap'
import Flatpickr from 'react-flatpickr'
import {Spanish} from 'flatpickr/dist/l10n/es'
import {toast} from 'react-toastify'
import moment from 'moment'

import img from '../../assets/img/vector-1.png'
import {Spinner} from '../Spinner'
// import {KTIcon} from '../../../_metronic/helpers'
import {IResDashboardInfo, ReportDashboard} from '../../graphql/types/dashboardTypes'
import {GET_INFO_DASHBOARD} from '../../graphql/queries/getDashboard'
import {useNetworkStatus} from '../../hooks/useNetworkStatus'
import {parsePrice} from '../../helpers'
import excelImage from '../../assets/img/excel.png'
import {useGetUser} from '../../hooks/useGetUser'
import {API} from '../../graphql/client'

export const InfoDashboard = () => {
  const {user} = useGetUser()
  const [gqlGetDashboardInfo, {data, loading, error}] =
    useLazyQuery<IResDashboardInfo>(GET_INFO_DASHBOARD)
  const isOnline = useNetworkStatus()
  const [isSearch, setIsSearch] = useState(false)
  const [reports, setReports] = useState<ReportDashboard | null>(null)
  const [flatPickerValues, setFlatPickerValues] = useState<
    string | number | Date | readonly (string | number | Date)[] | undefined
  >([new Date(new Date().setMonth(new Date().getMonth() - 1)), new Date()])

  const [datesValue, setDatesValue] = useState<{
    initialDate: string
    endDate: string
  }>({
    initialDate: moment().subtract(1, 'months').format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD'),
  })

  const [loadingExport, setLoadingExport] = useState(false)

  useEffect(() => {
    const {endDate, initialDate} = datesValue
    const variables = {
      initialDate,
      endDate,
    }
    gqlGetDashboardInfo({
      variables,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [datesValue])

  useEffect(() => {
    if (!data) return
    setReports(data.reportDashboard)
  }, [data])

  useEffect(() => {
    if (!error) return
    toast.error('Error: ' + error.message)
  }, [error])

  const handleDownload = async (name: 'ventas' | 'despachos', legibleName: string) => {
    if (!name) return
    if (!user?.tokenAuth.token) return
    const {token} = user.tokenAuth
    const myHeaders = new Headers()
    myHeaders.append('Authorization', `Bearer ${token}`)

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
    }

    setLoadingExport(true)

    try {
      const res = await fetch(
        `${API}/reportes/${name}/${moment(datesValue.initialDate).format('YYYY-MM-DD')}/${moment(
          datesValue.endDate
        ).format('YYYY-MM-DD')}`,
        requestOptions
      )
      if (!res.ok) throw new Error('Error al exportar')
      const blob = await res.blob()
      // console.log('blob', blob)
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      console.log('blob', blob)
      link.href = url
      link.download = `${legibleName}-${moment(datesValue.initialDate)
        .format('DD MMM')
        .replace('.', '')}-${moment(datesValue.endDate).format('DD MMM').replace('.', '')}.xlsx`
      document.body.appendChild(link)
      setLoadingExport(false)
      link.click()
    } catch (err) {
      setLoadingExport(false)
      toast.error(`ERROR: ${(err as {message: string}).message}`)
    }
  }

  const searchForDates = (e: Date[]) => {
    if (e.length === 1) return

    if (e && e.length === 2) {
      setIsSearch(true)
      const initialDate = new Date(e[0]).toISOString().split('T')[0]
      const endDate = new Date(e[1]).toISOString().split('T')[0]

      return setDatesValue({
        initialDate,
        endDate,
      })
    }
    setDatesValue({
      initialDate: moment().startOf('month').format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD'),
    })
  }

  const getColor = (idx: number) => {
    const colors = ['#f1416c', '#50cd89', '#ff8d00', '#ffc700', '#7239ea', '#E4E6EF']
    return colors[idx]
  }

  if ((loading && !isSearch) || reports == null) {
    return (
      <>
        <div className='col-md-6 col-lg-6 col-xl-6 col-xxl-3 mb-md-5 mb-xl-10'>
          <div
            className={`card card-flush bgi-no-repeat bgi-size-contain bgi-position-x-end`}
            style={{
              backgroundColor: '#F1416C',
              backgroundImage: `url('${img}')`,
            }}
          >
            <div className='card-header pt-5'>
              <div className='card-title d-flex flex-column'>
                <span className='fs-2hx fw-bold text-white me-2 lh-1 ls-n2'>
                  <Spinner size='14px' color='light' />
                </span>

                <span className='text-white opacity-75 pt-1 fw-semibold fs-6'>
                  <Placeholder as={Card.Title} animation='glow'>
                    <Placeholder xs={6} />
                  </Placeholder>
                </span>
              </div>
            </div>
            <div className='card-body d-flex align-items-end pt-0'>
              <div className='d-flex align-items-center flex-column mt-3 w-100'>
                <div className='d-flex justify-content-between fw-bold fs-6 text-white opacity-75 w-100 mt-auto mb-2'>
                  <span>
                    <Placeholder as={Card.Title} animation='glow'>
                      <Placeholder xs={6} />
                    </Placeholder>
                  </span>
                  <span>
                    <Placeholder as={Card.Title} animation='glow'>
                      <Placeholder xs={6} />
                    </Placeholder>
                  </span>
                </div>

                <div className='h-8px mx-3 w-100 bg-white bg-opacity-50 rounded'>
                  <div
                    className='bg-white rounded h-8px'
                    role='progressbar'
                    style={{width: '0%'}}
                    aria-valuenow={0}
                    aria-valuemin={0}
                    aria-valuemax={100}
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='col-md-6 col-lg-6 col-xl-6 col-xxl-3 mb-md-5 mb-xl-10'>
          <div className={`card card-flush`}>
            <div className='card-header pt-5'>
              <div className='card-title d-flex flex-column'>
                <span className='text-gray-400 pt-1 fw-semibold fs-6' style={{width: '180px'}}>
                  <p className='card-text placeholder-glow'>
                    <span className='placeholder col-7'></span>
                  </p>
                </span>
              </div>
            </div>

            <div className='card-body pt-2 pb-4 d-flex flex-wrap align-items-center'>
              <div className='d-flex flex-center me-5 pt-2'></div>

              <Spinner size='50px' />
            </div>
          </div>
        </div>
      </>
    )
  }
  const {quantitySales, quantitySalesClose, products, totalSales} = reports
  const porcentaje =
    quantitySales > 0 ? Math.floor(((quantitySalesClose ?? 0) * 100) / quantitySales) : 0

  console.log('products', products)

  return (
    <>
      <div className='col-12 d-flex align-items-center gap-2'>
        <div
          style={{
            flex: 1,
            maxWidth: '331px',
          }}
        >
          <div className='input-group'>
            <span className='input-group-text' id='basic-addon1'>
              <i className='bi bi-calendar3' />
            </span>
            <Flatpickr
              disabled={!isOnline}
              placeholder='Seleccione fecha(s)'
              className='form-control'
              onChange={(e) => {
                searchForDates(e)
                setFlatPickerValues(e)
              }}
              value={flatPickerValues}
              options={{
                mode: 'range',
                dateFormat: 'd F y',
                showMonths: 2,
                locale: Spanish,
                position: 'auto center',
              }}
            />
          </div>
        </div>
        {loading && <Spinner size='16px' />}
      </div>
      <div className='col-md-6 col-lg-6 col-xl-6 col-xxl-6 mb-md-5 mb-xl-10'>
        <div
          className={`card card-flush bgi-no-repeat bgi-size-contain bgi-position-x-end`}
          style={{
            backgroundColor: '#F1416C',
            backgroundImage: `url('${img}')`,
          }}
        >
          <div className='card-header pt-5'>
            <div className='card-title d-flex flex-column'>
              <span className='fs-2hx fw-bold text-white me-2 lh-1 ls-n2'>{quantitySales}</span>

              <span className='text-white opacity-75 pt-1 fw-semibold fs-6'>Ventas</span>
            </div>
          </div>
          <div className='card-body d-flex align-items-end pt-0'>
            <div className='d-flex align-items-center flex-column mt-3 w-100'>
              <div className='d-flex justify-content-between fw-bold fs-6 text-white opacity-75 w-100 mt-auto mb-2'>
                <span>{quantitySalesClose} Ventas cerradas</span>
                <span>{porcentaje}%</span>
              </div>

              <div className='h-8px mx-3 w-100 bg-white bg-opacity-50 rounded'>
                <div
                  className='bg-white rounded h-8px'
                  role='progressbar'
                  style={{width: `${porcentaje}%`}}
                  aria-valuenow={porcentaje}
                  aria-valuemin={0}
                  aria-valuemax={100}
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='col-md-6 col-lg-6 col-xl-6 col-xxl-6 mb-md-5 mb-xl-10'>
        <div className={`card card-flush`}>
          <div className='card-header pt-5'>
            <div className='card-title d-flex flex-column'>
              <div className='d-flex align-items-center'>
                <span className='fs-4 fw-semibold text-gray-400 me-1 align-self-start'>$</span>

                <span className='fs-2hx fw-bold text-dark me-2 lh-1 ls-n2'>
                  {parsePrice(totalSales || '').replace('$', '')}
                </span>

                {/* <span className='badge badge-light-success fs-base'>
                  <KTIcon iconName='arrow-up' className='fs-5 text-success ms-n1' /> 2.2%
                </span> */}
              </div>
              <span className='text-gray-400 pt-1 fw-semibold fs-6'>Información de productos</span>
            </div>
          </div>

          <div
            className='card-body pt-2 pb-4 d-flex flex-wrap align-items-center'
            style={{
              maxHeight: '80px',
              overflowY: 'auto',
            }}
          >
            <div className='d-flex flex-center me-5 pt-2'></div>

            <div className='d-flex flex-column content-justify-center flex-row-fluid'>
              {products.map(({product, soldValue}, idx) => (
                <div className='d-flex fw-semibold align-items-center' key={idx}>
                  <div
                    className='bullet w-8px h-3px rounded-2 me-3'
                    style={{backgroundColor: getColor(idx)}}
                  ></div>
                  <div className='text-gray-500 flex-grow-1 me-4'>{product}</div>
                  <div className=' fw-bolder text-gray-700 text-xxl-end'>
                    {parsePrice(soldValue)}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className='col-12'>
        <div className='card card-xl-stretch mb-xl-8'>
          {/* begin::Header */}
          <div className='card-header border-0 pt-5'>
            <h3 className='card-title align-items-start flex-column'>
              <span className='card-label fw-bold text-dark'>Documentos</span>
              <span className='text-muted mt-1 fw-semibold fs-7'>
                Desde {moment(datesValue.initialDate).format('DD [de] MMM')} hasta{' '}
                {moment(datesValue.endDate).format('DD [de] MMM')}{' '}
              </span>
            </h3>
          </div>
          {/* end::Header */}
          {/* begin::Body */}
          <div className='card-body pt-5'>
            <div className='d-flex align-items-sm-center mb-7'>
              {/* begin::Symbol */}
              <div className='symbol symbol-50px me-5'>
                <span className='symbol-label'>
                  <img src={excelImage} className='h-50 align-self-center' alt='' />
                </span>
              </div>
              {/* end::Symbol */}
              {/* begin::Section */}
              <div className='d-flex align-items-center flex-row-fluid flex-wrap'>
                <div className='flex-grow-1 me-2'>
                  <span className='text-gray-800 text-hover-primary fs-6 fw-bold'>Ventas</span>
                  <span className='text-muted fw-semibold d-block fs-7'>
                    Información de las ventas en el periodo de tiempo
                  </span>
                </div>
                <Button
                  title='Descargar'
                  variant='info'
                  disabled={loadingExport}
                  onClick={() => handleDownload('ventas', 'ventas')}
                >
                  {loadingExport ? (
                    <Spinner size='16px' color='light' />
                  ) : (
                    <i className='bi bi-download fs-2' />
                  )}
                </Button>
              </div>
              {/* end::Section */}
            </div>
            <div className='d-flex align-items-sm-center mb-7'>
              {/* begin::Symbol */}
              <div className='symbol symbol-50px me-5'>
                <span className='symbol-label'>
                  <img src={excelImage} className='h-50 align-self-center' alt='' />
                </span>
              </div>
              {/* end::Symbol */}
              {/* begin::Section */}
              <div className='d-flex align-items-center flex-row-fluid flex-wrap'>
                <div className='flex-grow-1 me-2'>
                  <span className='text-gray-800 text-hover-primary fs-6 fw-bold'>Despachos</span>
                  <span className='text-muted fw-semibold d-block fs-7'>
                    Información de despachos en el periodo de tiempo
                  </span>
                </div>
                <Button
                  title='Descargar'
                  disabled={loadingExport}
                  onClick={() => handleDownload('despachos', 'Despachos')}
                >
                  {loadingExport ? (
                    <Spinner size='16px' color='light' />
                  ) : (
                    <i className='bi bi-download fs-2' />
                  )}
                </Button>
              </div>
              {/* end::Section */}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
